module.exports = __webpack_public_path__ + "static/img/13.131aaa1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/17/zh/13.png
// module id = 8lde
// module chunks = 0